import type { schemas } from '@gonfalon/openapi/types';
import { getQueryClient } from '@gonfalon/react-query-client/getQueryClient';

import { getEnvironmentQuery } from './environments';

export function initializeEnvironment({
  projectKey,
  environmentKey,
  environment,
}: {
  projectKey: string;
  environmentKey: string;
  environment: schemas['Environment'];
}) {
  getQueryClient().setQueryData(getEnvironmentQuery({ projectKey, environmentKey }).queryKey, environment);
}
